module.exports = __webpack_public_path__ + "static/img/Pic-mzd.3adc36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/Pic-mzd.png
// module id = PWF2
// module chunks = 63